import * as Redux from 'redux';
import { IAutocompleteResults } from '../../global/state-helpers/autocomplete'
import { autocompleteModel } from '../../global/reducers/autocomplete-model';
import { searchTermModel } from '../../search-page/reducers/search-term-model';


export interface IState {
    dispatch: Redux.Dispatch<IState>;
    autocompleteModel: IAutocompleteResults;
    searchTermModel: string;
}

export const rootReducer = Redux.combineReducers({
    autocompleteModel,
    searchTermModel
});